import { render } from "./Home.vue?vue&type=template&id=5fa1e021&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./custom-home.scss?vue&type=style&index=0&id=5fa1e021&lang=scss&scoped=true"
import "./Home.vue?vue&type=style&index=1&id=5fa1e021&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa1e021"]])

export default __exports__